let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电订单编号',
        props: 'orderNo',
        minWidth: 250,
    },
    {
        label: '充电IMEI编号',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '充电业务归属',
        props: 'belongTo',
        minWidth: 180,
    },
    {
        label: '订单状态',
        props: 'payStatusName',
        minWidth: 150,
    },
    {
        label: '充电用户',
        props: 'custPhone',
        minWidth: 150,
    },
    {
        label: '订单属性',
        props: 'orderProperty',
        minWidth: 200,
        formatter:(row)=>{
            if(row.orderProperty == '01'){
                return `正常`
            }else{
                return `异常`
            }
        }
    },
    {
        label: '启动方式',
        props: 'startWayName',
        minWidth: 200,
    },
    {
        label: '开始时间',
        props: 'beginTime',
        minWidth: 200,
    },
    {
        label: '结束方式',
        props: 'endWayName',
        minWidth: 200,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 200,
    },
    {
        label: '充电电量（kw·h）',
        props: 'chargeVal',
        minWidth: 200,
    },

    {
        label: '充电时长',
        props: 'chargeHourMinute',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
];

//充电记录列表项
pageConfig.chargeRecordColumns = [
    {
        label: '订单编号',
        props: 'orderNo',
        minWidth: 200,
    },
    {
        label: '充电桩编号',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 180,
        tooltip:true,
    },
    {
        label: '账号类型',
        props: 'custTypeName',
        minWidth: 180,
        tooltip:true,
    },
    {
        label: '开始时间',
        props: 'beginTime',
        minWidth: 320,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 200,
    },
    {
        label: '充电时长（分）',
        props: 'chargeMin',
        minWidth: 200,
    },
    {
        label: '订单属性',
        props: 'orderPropertyName',
        minWidth: 120,
    },
    {
        label: '充电电量（kW·h）',
        props: 'chargeVal',
        minWidth: 200,
    },
];

//抢修列表项
pageConfig.repairColumns = [
    {
        label: '充电桩编号',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '维修工单',
        props: 'repairNo',
        minWidth: 200,
    },
    {
        label: '所属站点',
        props: 'stationName',
        minWidth: 320,
    },
    {
        label: '维修状态',
        props: 'repairStatus',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.repairStatus == '01') {
                return "未维修";
            }
            else {
                return '已维修'
            }
        }
    },
    {
        label: '维修结果',
        props: 'repairResult',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.repairResult == '01') {
                return "未修复";
            }
            else {
                return '已修复'
            }
        }
    },
    {
        label: '申请日期',
        props: 'applyTime',
        minWidth: 200,
    },
    {
        label: '维修天数',
        props: 'repairDateNum',
        minWidth: 200,
    },
    {
        label: '申请原因',
        props: 'applyReason',
        minWidth: 120,
    },
    {
        label: '维修回执',
        props: 'corpReturn',
        minWidth: 200,
    },
    {
        label: '维修人',
        props: 'repairPerson',
        minWidth: 180,
    },
];

//故障记录列表项
pageConfig.faultRecordColumns = [
    {
        label: '充电桩编码',
        props: '',
        minWidth: 200,
    },
    {
        label: '故障时间',
        props: '',
        minWidth: 180,
        tooltip:true,
    },
    {
        label: '故障描述',
        props: '',
        minWidth: 320,
    },
    {
        label: '故障备注',
        props: '',
        minWidth: 200,
    },
];

// 关联账号详情列表
pageConfig.relationColumns = [
    {
        label: '充电桩编码',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '关联账号类型',
        props: 'custTypeName',
        minWidth: 200,
        tooltip:true,
    },
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '关联时间',
        props: 'lastModifiedWhen',
        minWidth: 320,
    },
]

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '订单管理',
    },
    {
        type: 'title',
        name: '私桩充电订单'
    },
    {
        type: 'title',
        name: '正常订单'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';


// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '订单管理',
    },
    {
        type: 'title',
        name: '私桩充电订单',
    },
    {
        type: 'router',
        name: '正常订单',
        router: 'normalList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];
// 详情的面包屑
pageConfig.unusualDetailBreadCrumb = [
    {
        type: 'title',
        name: '订单管理',
    },
    {
        type: 'title',
        name: '私桩充电订单',
    },
    {
        type: 'router',
        name: '异常订单',
        router: 'unusualList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};



export default pageConfig;
